<bz-loading *ngIf="showLoading" [message]="loadingMessage">
</bz-loading>

<div class="container-fluid viewer-detail">
  <div class="row viewer-detail__header">
    <div class="viewer-detail__export">
      <i class="bz-icon bz-icon bz-icon-open-outline" ></i>
      <span *ngIf="!downloadingFile">{{ 'TRACE_CONFIGURATION.EXPORT'| translate }}</span>
      <span class="viewer-detail__export--downloading" *ngIf="downloadingFile">{{ 'GLOBAL.DOWNLOADING' | translate }}</span>
    </div>
  </div>
  <div class="row">
    <ul class="viewer-detail__container">
      <li *ngFor="let content of contentEntries">
        {{content.MessageLog}}
      </li>
      <div class="viewer-detail__loadMore">
        <bz-loading *ngIf="gettingRows" [size]="'s'"></bz-loading>
        <button class="viewer-detail__btnLoad" (click)="loadMoreDetails()" *ngIf="hasMoreResults && !gettingRows">{{ 'GLOBAL.LOAD_MORE' | translate }}</button>
      </div>
    </ul>
  </div>
</div>
